import React, { useState } from "react";
import { http, getCurrentUserURL, loginURL } from '../services/http';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login: setAuthUser, logout, user } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('error') === 'access_denied') {
      setError('You do not have permission to access the dashboard.');
      return;
    }
    if (user) logout();
    // eslint-disable-next-line
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await http.post(loginURL(), { user: email, password });
      const { data: userData } = await http.get(getCurrentUserURL());
      setAuthUser(userData);
      navigate("/");
    } catch (err) {
      setError("Invalid email or password");
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', width: '100vw', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(195deg, #6a82fb, #fc5c7d)',
    }}>
      <div style={{
        background: '#fff', borderRadius: 12, padding: '2rem',
        width: '100%', maxWidth: 420, boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: 'rgb(52, 71, 103)' }}>ScoreCloud Dashboard</h1>
          <p style={{ fontSize: 14, color: 'rgb(123, 128, 154)', marginTop: 8 }}>Sign in with your ScoreCloud account</p>
        </div>
        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <input
            type="text" id="email" placeholder="Email"
            value={email} onChange={e => setEmail(e.target.value)}
            autoComplete="username"
            style={{ padding: '12px 14px', fontSize: 16, border: '1px solid #ccc', borderRadius: 6, outline: 'none' }}
          />
          <input
            type="password" id="password" placeholder="Password"
            value={password} onChange={e => setPassword(e.target.value)}
            autoComplete="current-password"
            style={{ padding: '12px 14px', fontSize: 16, border: '1px solid #ccc', borderRadius: 6, outline: 'none' }}
          />
          {error && <p style={{ color: '#d32f2f', textAlign: 'center', fontSize: 14, margin: 0 }}>{error}</p>}
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: '12px', fontSize: 16, fontWeight: 600, color: '#fff', border: 'none',
              borderRadius: 6, cursor: loading ? 'wait' : 'pointer',
              background: 'linear-gradient(195deg, #6a82fb, #fc5c7d)',
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
